import { initDensity, initTheme } from "@micropod/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { ErrorBoundary } from "./ui/ErrorBoundary";
import "./shell.css";

// Before first paint, or the wrong theme flashes on every load and the rows resize under
// the agent a moment after they land.
initTheme();
initDensity();

// §6: one orchestrated moment, once per session. A fresh tab gets it; navigating
// inside the app does not, and neither does a refetch.
try {
  if (!sessionStorage.getItem("mp_entered")) {
    sessionStorage.setItem("mp_entered", "1");
    const shell = document.getElementById("root");
    shell?.classList.add("entering");

    // `entering` is a gate, not a state. Left on, every pane React remounts on a view
    // change would animate in again — and §6 says this plays once, then it is over.
    //
    // The gate closes on the plate's own animationend rather than on a fixed timer,
    // because the sequence starts when React commits, not when this module runs. A
    // timer short enough to feel tidy is a timer that truncates the entry on a slow
    // first paint. The fallback covers reduced-motion, where nothing fires at all.
    const close = () => shell?.classList.remove("entering");
    shell?.addEventListener("animationend", (e) => {
      if (e.animationName === "plateIn") close();
    });
    setTimeout(close, 1500);
  }
} catch {
  // Private windows throw on access. The animation is a nicety, not a requirement.
}

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
